(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('InstancesService', InstancesService);

    InstancesService.$inject = ['$rootScope', '$http'];

    function InstancesService ($rootScope, $http) {

        return {
            getInstances: getInstances,
            executeAction: executeAction,
            saveInstance: saveInstance
        };

        function getInstances(pageable, runningAndStopped) {
            return $http.get(SERVER_API_URL+"api/admin/instances?page=" + pageable.page + "&sort=" + pageable.sort +
                "&runningAndStopped=" + runningAndStopped);
        }

        function executeAction(instanceId, action) {
            return $http.post(SERVER_API_URL+"api/admin/" + action + "/" + instanceId);
        }

        function saveInstance(instance) {
            return $http.post(SERVER_API_URL+"api/admin/save", instance);
        }
    }
})();
